import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import { groupBy } from "lodash";
import type { ElForm } from "element-ui/types/form";
import uuid4 from "uuid";
import style from "./style.vue";
import { EmpServiceAPIActions } from "@/services/empService";
import { appEnvConfig } from "@/configs/appConfigs";
import baseAPIService from "@/services/base/baseAPIService";
import bindClassDialog from "@/views/components/newDisplayConfig/bindClassDialog";
import ChooseGoodsClass from "@/views/components/chooseGoodsClass";
import { noop, numberToArray } from "@/util";
import { Functions } from "@/library/utils/functions";

export const defaultImg = "https://ssl-picture.tenyun.runsasoft.com/2d97c9b0-83ab-11ea-b0d5-8b89156e3a17";
@Component({
	components: {},
	mixins: [style],
})
export default class LabelClass extends Vue {
	@Prop({ default: () => {} })
	value: DisplayLabelClassData;

	@Prop({ default: false })
	disabled: boolean;

	@Prop({ default: () => [] })
	attrButeList: ItemArray;

	@Prop()
	fromPage: number;

	@Inject({ default: 2 })
	mode: number;

	@Inject({ default: () => [] })
	goodsClassList: Function;

	data: DisplayLabelClassData = {};

	tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	uuid = "";

	$refs: {
		form: ElForm;
	};

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	mounted() {
		this.uuid = uuid4();
	}

	/**
	 * 分类导航切换显示不显示是，默认添加一个全部
	 */
	labelClassChange(data) {
		data.desc.showClassType === 2
			? this.$confirm("选择不显示分类导航时，已配置到该分类导航的分类均将失效，请谨慎操作！", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
			  }).then(
					(res) => {
						if (res === "confirm") {
							this.setLabelClassDefault();
						} else {
							data.desc.showClassType = 1;
						}
					},
					() => {
						data.desc.showClassType = 1;
					},
			  )
			: this.setLabelClassDefault();
	}

	setLabelClassDefault() {
		this.data.desc =
			this.data.desc.showClassType === 1
				? {
						showClassType: 1,
						list: [
							// {
							//   classId: 0,
							//   isAllClass: 1,
							//   className: "全部",
							//   classPic: "",
							//   parentId: 0,
							//   relationClass: "",
							//   relationList: [],
							// },
						],
				  }
				: {
						showClassType: 2,
						list: [],
				  };
	}

	beforeUploadNavImg(file) {
		const isJPG = file.type === "image/jpeg";
		const isPNG = file.type === "image/png";
		const isGIF = file.type === "image/gif";
		const isLt1000KB = file.size / 1024 < 300;

		if (!isJPG && !isPNG && !isGIF) {
			this.$message.error("上传图片只支持 JPG/JPEG/PNG/GIF 格式!");
		}
		if (!isLt1000KB) {
			this.$message.error(`上传图片大小不能超过 ${300}KB!`);
		}
		return (isJPG || isPNG || isGIF) && isLt1000KB;
	}

	uploadNavImgSuccess(index, res: HttpAPIRetItem<any>) {
		this.data.desc.list[index].classPic = res.content;
	}

	/**
	 *  选择分类
	 * @param type
	 * @param index
	 */
	selectClass(type: string, index: number) {
		if (this.disabled) {
			return;
		}
		// this.fromPage === 6 || this.fromPage === 8 ? this.siteClassSelect(type, index) : this.sgClassSelect(type, index);
		this.sgClassSelect(type, index);
	}

	/**
	 *  网点选择分类
	 * @param type
	 * @param index
	 */
	siteClassSelect(type: string, index: number) {
		const selected = this.data.desc.list[index].classList.flatMap((v) => v.classIds);
		ChooseGoodsClass.open({ dataSource: this.goodsClassList(), selected }).then((result) => {
			const childrenStore = this.goodsClassList().flatMap((v) => v.children);
			const childrenList = childrenStore.filter((v) => result.includes(v.classId));
			const childrenGroup = groupBy(childrenList, "parentId");
			this.data.desc.list[index].classList = Object.keys(childrenGroup).map((k) => {
				const classIds = childrenGroup[k].map((v) => v.classId);
				return { classIds };
			});
		}, noop);
	}

	/**
	 *  网点组选择分类
	 * @param type
	 * @param index
	 */
	sgClassSelect(type: string, index: number) {
		const defaultCheckedKeys = this.data.desc.list[index].relationList.flatMap((v) => (v.attrValues as string).split(","));
		bindClassDialog.open({ defaultCheckedKeys }).then((res: any[]) => {
			const classList = groupBy(
				res.filter((v) => v.isLeafe),
				"class_code",
			);
			const keys = Object.keys(classList);
			const resValue = keys.map((v) => {
				return {
					attrCode: v,
					attrName: this.getAttrName(v),
					selectNames: classList[v].map((c) => c.value_name),
					attrValues: classList[v].map((c) => c.value_no).join(","),
				};
			});
			this.data.desc.list[index].relationList = resValue;
			this.data.desc.list[index].classList = resValue as any;

			this.$nextTick(() => {
				this.$refs.form.validate(noop);
			});
		}, noop);
	}

	getAttrName(attrCode) {
		return this.attrButeList.find((v) => {
			return v.attrCode === attrCode;
		}).attrName;
	}

	getClassText(val: LabelClassItem): { text?: string; code?: string }[] {
		return this.fromPage === 6 || this.fromPage === 8 ? this.computedSiteClassName(val) : this.computedSgClassName(val);
	}

	computedSiteClassName(val: LabelClassItem): { text?: string; code?: string }[] {
		if (val.classList && val.classList.length) {
			const listString = val.classList
				.filter((v) => v)
				.map((i: any) => {
					return {
						text: `${i.attrName}${
							i.selectNames && i.selectNames.length
								? `-${i.selectNames
										.filter((v) => v)
										.map((v) => {
											return v;
										})
										.join("，")}`
								: ""
						}`.trim(),
						code: i.attrCode,
					};
				});
			return listString && listString.length ? listString : [];
		} else {
			return [];
		}
	}

	computedSgClassName(val: LabelClassItem): { text?: string; code?: string }[] {
		if (val.relationList && val.relationList.length) {
			const listString = val.relationList
				.filter((v) => v)
				.map((i: any) => {
					return {
						text: `${i.attrName}${
							i.selectNames && i.selectNames.length
								? `-${i.selectNames
										.filter((v) => v)
										.map((v) => {
											return v;
										})
										.join("，")}`
								: ""
						}`.trim(),
						code: i.attrCode,
					};
				});
			return listString && listString.length ? listString : [];
		} else {
			return [];
		}
	}

	/**
	 * 删除选中的主档分类
	 * @param type
	 * @param index
	 * @param code
	 */
	deleteSelectClass(listIndex: number, classIndex: number, code?) {
		this.fromPage === 6 || this.fromPage === 8 ? this.deleteSiteSelectClass(listIndex, classIndex, code) : this.delSgSelectClass(listIndex, classIndex, code);
	}

	delSgSelectClass(listIndex: number, classIndex: number, code?) {
		if (code) {
			this.data.desc.list[listIndex].relationList = (this.data.desc as any).list[listIndex].relationList.filter((v) => {
				return v.attrCode !== code;
			});
		} else {
			this.data.desc.list[listIndex].relationList = [];
		}
	}

	deleteSiteSelectClass(listIndex: number, classIndex: number, code?) {
		this.data.desc.list[listIndex].classList.splice(classIndex, 1);
		this.data.desc.list[listIndex].relationList = (this.data.desc as any).list[listIndex].relationList.filter((v) => {
			return v.attrCode !== code;
		});
	}

	/**
	 * 删除分类导航
	 * @param type
	 * @param index
	 */
	handleDeleteNavItem(type: string, index: number) {
		this.$confirm("是否删除？", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			closeOnClickModal: false,
			type: "warning",
		}).then((res) => {
			if (res === "confirm") {
				this.data.desc.list = (this.data.desc as any).list.filter((v, ind) => {
					return ind !== index;
				});
			}
		}, noop);
	}

	/**
	 * 添加导航分类
	 */
	addNav() {
		!this.data.desc.list && (this.data.desc.list = []);
		const listLastItemIndex = this.data.desc.list.length;
		this.data.desc.list.push(this.newLabelClassItem(listLastItemIndex));
	}

	newLabelClassItem = (index) => {
		return {
			classId: 0,
			isAllClass: 0,
			className: `标题${index + 1}`,
			classPic: "",
			parentId: 0,
			relationClass: "",
			relationList: [],
			classList: [],
		};
	};

	render(h) {
		return (
			<div class="label-class" key={this.data.sort}>
				{this.fromPage !== 6 && this.fromPage !== 8 && (
					<el-radio-group v-model={this.data.desc.showClassType} class="width-100 r-pb-14" onChange={() => this.labelClassChange(this.data)}>
						<el-radio label={1}>显示分类导航</el-radio>
						<el-radio label={2}>不显示分类导航</el-radio>
					</el-radio-group>
				)}

				{this.data.desc.showClassType === 1 && (
					<div class="label-class-list">
						<el-form props={{ model: this.data }} ref="form" disabled={this.disabled}>
							{Array.isArray(this.data.desc.list) && (
								<draggable draggable={".nav-config-item"} preventOnFilter={false} filter={".title"} disabled={this.disabled} scroll={true} v-model={this.data.desc.list} scroll-sensitivity={150} force-fallback={true}>
									{this.data.desc &&
										Array.isArray(this.data.desc.list) &&
										this.data.desc.list.map((val, index) => {
											// if (index < this.data.desc.list.length - 1) {
											return (
												<div class="nav-config-item" key={this.uuid + index}>
													<div class="nav-config-cont">
														<div class="nav-config-img">
															<img src={val.classPic || defaultImg} alt="" class="img" />
															<el-upload
																action={this.imgTpConfig}
																headers={this.tokenData}
																before-upload={this.beforeUploadNavImg}
																maxSize={300}
																data={{ corpId: baseAPIService.resolveCorpId() }}
																{...{
																	props: {
																		"on-success": this.uploadNavImgSuccess.bind(this, index),
																		"on-error": () => {
																			this.$message.error("图片上传错误，请稍后重试！");
																		},
																	},
																}}
																show-file-list={false}>
																<span class="modify">修改</span>
															</el-upload>
														</div>
														<div class="nav-config-info">
															<el-form-item class="title" label="标题" prop={`desc.list[${index}].className`} rules={{ required: true, message: " ", trigger: "change" }}>
																<el-input v-model={val.className} style="width:88%" maxlength="6" />
															</el-form-item>
															<p class="classes">
																<div class="class-left">
																	<el-form-item label="分类" class="classes-item" prop={`desc.list[${index}].relationList`} rules={{ required: true, message: "请选择分类", trigger: "change" }}>
																		<div class="wid-95">
																			<p
																				class={["scopeSpan", this.disabled && "disabled"]}
																				onClick={() => {
																					this.selectClass("LabelClass", index);
																				}}>
																				请选择
																			</p>
																			{this.getClassText(val).map((value, i) => {
																				return (
																					<p class="selectClassItem">
																						<el-tooltip class="item" effect="dark" content={value.text} placement="top">
																							<span>{value.text}</span>
																						</el-tooltip>
																						<i class="font-normal" onClick={this.deleteSelectClass.bind(this, index, i, value.code)}>
																							X
																						</i>
																					</p>
																				);
																			})}
																		</div>
																	</el-form-item>
																</div>
															</p>
														</div>
													</div>
													{!this.disabled && <i class="el-icon-error redText delete" onClick={this.handleDeleteNavItem.bind(this, "LabelClass", index)} />}
												</div>
											);
											// }
										})}
								</draggable>
							)}
							{this.data.desc.list.length < 20 && (
								<div class="nav-config-item r-mt-10">
									<span class="text-decort" onClick={this.addNav.bind(this)}>
										+添加一个分类导航
									</span>
								</div>
							)}
							{/* {this.data.desc.list.length > 0 && (
                <div class="nav-config-item" style="margin-bottom:0">
                  <div class="nav-config-cont">
                    <div class="nav-config-img">
                      <img
                        src={this.data.desc.list[this.data.desc.list.length - 1].classPic || defaultImg}
                        alt=""
                        class="img"
                      />
                      <el-upload
                        action={this.imgTpConfig}
                        headers={this.tokenData}
                        data={{ corpId: baseAPIService.resolveCorpId() }}
                        {...{
                          props: {
                            "on-success": this.uploadNavImgSuccess.bind(this, this.data.desc.list.length - 1),
                            "on-error": () => {
                              this.$message.error("图片上传错误，请稍后重试！");
                            },
                          },
                        }}
                        show-file-list={false}>
                        <span class="modify">修改</span>
                      </el-upload>
                    </div>
                    <div class="nav-config-info">
                      <p class="title">
                        <el-form-item
                          label="标题"
                          prop={"desc.list." + (this.data.desc.list.length - 1) + ".className"}
                          rules={[{ required: true, message: " ", trigger: ["change","blur"] }]}
                          style="70px">
                          <el-input
                            v-model={this.data.desc.list[this.data.desc.list.length - 1].className}
                            maxlength="4"
                            style="width: 70%"
                          />
                        </el-form-item>
                      </p>
                      <p class="classes">
                        <span class="class-left text-grey-17">
                          分类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;全部分类（系统保留）
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )} */}
						</el-form>
					</div>
				)}
				{this.data.desc.showClassType === 1 && <p class="tip blockTip">注：建议图片分辨率为150px*150px，大小不超过300k，支持jpg、gif、png格式</p>}
			</div>
		);
	}
}
